export default "__VITE_ASSET__pKYIeivm__"